import { TicketsTab } from "@features/tickets/components/tabs/TicketsTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tickets/")({
  loader: requirePermission(PERMISSIONS.TICKETS.TICKETS.VIEW),
  staticData: {
    title: "Tickets",
    showInTab: false,
    showInBreadcrumb: true,
  },
  component: TicketsTab,
});
